import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const TestimonialQuotes = ({ quote, author }) => {
  return (
    <Box
      sx={{
        width: "100%",
        py: 6,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "700px",
          mx: "auto",
          px: { xs: 2, md: 4 },
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            maxWidth: "800px",
            position: "relative",
            width: "100%",
            textAlign: "center",
          }}
        >
          <Box sx={{ position: "relative", mb: 4 }}>
            <Typography
              variant="h3"
              component="div"
              sx={{
                fontStyle: "italic",
                fontFamily: "serif",
                fontWeight: 600,
                fontSize: { xs: "1.5rem", md: "1.75rem" },
                lineHeight: 1.6,
                textAlign: "center",
              }}
            >
              {quote ||
                "\"I'm born and raised in Ballard and it's really fun challenging my Seattle knowledge, I feel like I learn more from it!\""}
            </Typography>

            <Typography
              sx={{
                mt: 3,
                textAlign: "right",
                fontSize: { xs: "1.1rem", md: "1.2rem" },
                fontWeight: 500,
              }}
            >
              {author || "- Seattle Wordy player"}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default TestimonialQuotes;
